import { render, staticRenderFns } from "./HoldDialog.vue?vue&type=template&id=b3c2507e&scoped=true"
import script from "./HoldDialog.vue?vue&type=script&lang=js"
export * from "./HoldDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c2507e",
  null
  
)

export default component.exports